import { useTranslation } from "react-i18next";
import React, { useCallback } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function MessageBox(props) {
  const { open, onClose, title, text, handleResponse, buttons, yesText="Ja", noText="Nein", okText="Ok", cancelText="Abbrechen" } = props;
  const { t } = useTranslation();
  const drawButtons = useCallback(() => {
    var buttonElements = null;
    switch (buttons) {
      case "YESNO":
        buttonElements = (
          <>
            <Button onClick={() => handleResponse("NO")} color="primary">
              {t(noText)}
            </Button>
            <Button
              onClick={() => handleResponse("YES")}
              variant="contained"
              color="primary"
              autoFocus
            >
              {t(yesText)}
            </Button>
          </>
        );
        break;
      case "YESNOCANCEL":
        buttonElements = (
          <>
            <Button onClick={() => handleResponse("CANCEL")} color="primary">
              {t(cancelText)}
            </Button>
            <Button onClick={() => handleResponse("NO")} color="primary">
              {t(noText)}
            </Button>
            <Button
              onClick={() => handleResponse("YES")}
              variant="contained"
              color="primary"
              autoFocus
            >
              {t(yesText)}
            </Button>
          </>
        );
        break;
      case "OKCANCEL":
        buttonElements = (
          <>
            <Button onClick={() => handleResponse("CANCEL")} color="primary">
              {t(cancelText)}
            </Button>
            <Button
              onClick={() => handleResponse("OK")}
              variant="contained"
              color="primary"
              autoFocus
            >
              {t(okText)}
            </Button>
          </>
        );
        break;
      default:
        buttonElements = (
          <>
            <Button
              onClick={() => handleResponse("OK")}
              variant="contained"
              color="primary"
              autoFocus
            >
              {t(okText)}
            </Button>
          </>
        );
        break;
    }
    return buttonElements;
  }, [buttons, handleResponse]);
  const msgcontent = () => {
    if (typeof text === "string") {
      return (
        <DialogContentText id="alert-dialog-description">
          {text}
        </DialogContentText>
      );
    } else if (typeof text === "object") {
      if (text === null) return null;
      return text.map((element, key) => {
        return (
          <DialogContentText key={key} id="alert-dialog-description">
            {element}
          </DialogContentText>
        );
      });
    } else {
      console.log(typeof text);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>{msgcontent()}</DialogContent>
      <DialogActions>{drawButtons()}</DialogActions>
    </Dialog>
  );
}
